import AttrLabel from '@SidePanel/Components/AttrLabel';
import useEmailEditor from '@hooks/useEmailEditor';
import useLink from '@hooks/useLink';
import {
    Box,
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    Popover,
    TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSlate } from 'slate-react';

function EditLink() {
    const { t } = useTranslation();
    const { url, text } = useLink();
    const editor = useSlate();
    const { linkOpen, setLinkOpen } = useEmailEditor();

    const [textValue, setTextValue] = useState(text);
    const [urlValue, setUrlValue] = useState(url);

    useEffect(() => {
        if (linkOpen) {
            setTextValue(text);
            setUrlValue(url);
        }
    }, [linkOpen]);

    return (
        <Dialog
            open={linkOpen}
            hideBackdrop
            onClose={() => setLinkOpen(false)}
            PaperProps={{
                sx: {
                    borderRadius: 4,
                },
            }}
        >
            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2,
                        alignItems: 'center',
                    }}
                >
                    <AttrLabel>{t('Text')}</AttrLabel>
                    <TextField
                        size="small"
                        placeholder={t('Text')}
                        value={textValue || ''}
                        onChange={e => setTextValue(e.target.value)}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2,
                        alignItems: 'center',
                        mt: 2,
                    }}
                >
                    <AttrLabel>{t('Link')}</AttrLabel>
                    <TextField
                        dir="ltr"
                        size="small"
                        placeholder="https://example.com"
                        value={urlValue || ''}
                        onChange={e => setUrlValue(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    size="small"
                    color="error"
                    onClick={() => {
                        editor.unwrapLink();
                        setLinkOpen(false);
                    }}
                >
                    {t('Remove')}
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                        editor.wrapLink(urlValue, textValue);
                        setLinkOpen(false);
                    }}
                    disabled={!urlValue || !textValue}
                >
                    {t('Apply')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditLink;
